
const products = [
  {
    id: "1",
    img: "/Images/Ourteam/team/24.jpg",
    Dname: "AKHILESH PANDEY",
    Ddesignation: "Senior Software Developer",
  },
  {
    id: "2",
    img: "/Images/Ourteam/team/15.jpg",
    Dname: "MURLI KUMAR",
    Ddesignation: "Senior UI Developer",
  },
  {
    id: "3",
    img: "/Images/Ourteam/team/11.jpg",
    Dname: "KRITESH POKHRIYAL",
    Ddesignation: "Senior Software Developer",
  },
  {
    id: "4",
    img: "/Images/Ourteam/team/17.jpg",
    Dname: "PRAMENDU THAKUR",
    Ddesignation: "Software Developer",
  },
  {
    id: "5",
    img: "/Images/Ourteam/team/18.jpg",
    Dname: "SAGAR BISHNOI",
    Ddesignation: "Business Intelligence Analyst",
  },
  {
    id: "6",
    img: "/Images/Ourteam/team/26.jpg",
    Dname: "SAKSHI SHARMA",
    Ddesignation: "Jr. Developer",
  },
  {
    id: "7",
    img: "/Images/Ourteam/team/gautam.jpg",
    Dname: "Gautam Jangir",
    Ddesignation: "Jr. Developer",
  },
  {
    id: "8",
    img: "/Images/Ourteam/team/nitika.jpg",
    Dname: "Nitika Barhoi",
    Ddesignation: "Graduate Engineer trainee",
  }
];

export default products;
